import { render } from "./PageAccessEdtor.vue?vue&type=template&id=d6b68048"
import script from "./PageAccessEdtor.vue?vue&type=script&lang=js"
export * from "./PageAccessEdtor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__